import { EmailPreviewModal } from "./components/Modal";
import { confirmable, createConfirmation } from "../../../hooks/DialogMountPoint";
import { EmailPreviewModalProps } from "./types";
import { FiledEmailType } from "../../../types/EmailType";

export function openEmailPreviewModel(data: FiledEmailType) : Promise<void> {
    return createConfirmation<EmailPreviewModalProps, void>(confirmable(EmailPreviewModal))({
        data,
        dialogId: `field_email_${data.graphId}`
    });
};